import { useCallback, useRef } from 'react';

export function useSingleRequest<F extends () => void>({
  onRequestLock,
  onRequestUnLock,
}: {
  onRequestLock?: F;
  onRequestUnLock?: F;
} = {}) {
  const lock = useRef(false);
  const lockRequest = useCallback(() => {
    lock.current = true;
    onRequestLock?.();
  }, [onRequestLock]);

  const unlockRequest = useCallback(() => {
    lock.current = false;
    onRequestUnLock?.();
  }, [onRequestUnLock]);

  const wrap = useCallback(
    <T extends (...args: any[]) => Promise<any>>(fn: T) =>
      (...args: any[]) => {
        if (!lock.current) {
          lockRequest();
          fn(...args).finally(unlockRequest);
        }
      },
    [lockRequest, unlockRequest]
  );
  return { wrap, lockRequest, unlockRequest };
}
